import { cx } from "@/utils";

import styles from "./Drawer.module.css";

type DrawerFooterProps = React.HTMLProps<HTMLDivElement>;

const DrawerFooter: React.FunctionComponent<DrawerFooterProps> = ({
  className,
  ...props
}) => {
  return (
    <>
      <footer
        className={cx(styles.footer, styles.padX, className)}
        {...props}
      />
    </>
  );
};

export default DrawerFooter;
